import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { consumeNavSeed, saveNavCreds } from './utils/navCreds';

// 导航页账密种子：必须在 React 挂载前消费——买家端 path="*" 兜底路由用 <Navigate to="/buyer/home" replace />
// 改写 URL，其子组件 effect 先于 App 父级 effect 执行，hash 在被读取前就被丢掉（已实测复现）
const navSeed = consumeNavSeed();
if (navSeed) saveNavCreds(navSeed.u, navSeed.p);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
